import React, { memo, useState } from 'react';

import PropTypes from 'prop-types';

import { useDevice } from '@bonnet/next/device';

import {
    Button,
    DataTable,
    DisclaimerText,
    Section,
    SideBarToModal,
} from 'reaxl';

function WarrantyModalComponent({
    warranty = {},
    label = '',
    handleCTAClick = () => { },
    buttonProps,
}) {

    const [showModal, setShowModal] = useState(false);
    const device = useDevice();
    const isXs = device?.is?.xs ?? false;

    const { warrantyType = '', warrantyData = {}, disclaimer } = warranty;

    const dataTable = (data) => (
        <DataTable
            striped
            data={data}
        >
            <DataTable.Column
                dataKey="name"
            />
            <DataTable.Column
                className="text-right"
                dataKey="value"
            />
        </DataTable>
    );

    const warrantyTitle = `${warrantyType} Warranty${warrantyType === 'Limited' ? ' Details' : ''}`;

    const renderContent = () => {
        if (warrantyType === 'Factory') {
            const factoryWarrantyData = Object.keys(warrantyData).map((k) => ({
                name: warrantyData[k].label,
                value: warrantyData[k].details,
            }));

            return dataTable(factoryWarrantyData);
        }

        if (warrantyType === 'Battery') {
            const batteryWarrantyData = Object.keys(warrantyData).map((k) => ({
                name: warrantyData[k].label,
                value: warrantyData[k].details,
            }));

            return (
                <>
                    {dataTable(batteryWarrantyData)}
                    <DisclaimerText>{disclaimer}</DisclaimerText>
                </>
            );
        }

        if (warrantyType === 'Limited' && (warrantyData.disclaimer || warrantyData.details)) {
            if (warrantyData.disclaimer) {
                return warrantyData.disclaimer;
            }

            const limitedWarrantyCoverageData = warrantyData.data && Object.entries(warrantyData.data).map(([name, value]) => ({ name, value }));

            return (
                <Section
                    alignment="left"
                    uiContext="section-5"
                    heading={warrantyData.title}
                    headingClassName="margin-bottom-3"
                >
                    {dataTable(limitedWarrantyCoverageData)}
                    {warrantyData.details}
                </Section>
            );

        }

        return null;
    };

    const modalContent = renderContent();

    return !!modalContent && (
        <>
            <Button
                onClick={(event) => {
                    setShowModal(true);
                    handleCTAClick(event, { warrantyType });
                }}
                {...buttonProps}
            >
                {label}
            </Button>

            <SideBarToModal
                collapsed={isXs}
                title={warrantyTitle}
                content={modalContent}
                sideBarOptions={{
                    fullWidth: true,
                }}
                modalOptions={{
                    scrollPanel: false,
                    bsSize: 'small',
                }}
                show={showModal}
                onHide={() => setShowModal(false)}
            />
        </>
    );

}

WarrantyModalComponent.propTypes = {
    /**
     * data for warranty modal {warrantyType, warrantyData}
     */
    warranty: PropTypes.object,
    /**
     * the text for the modal CTA
     */
    label: PropTypes.string,
    /**
     * onClick method for modal CTA
     */
    handleCTAClick: PropTypes.func,
    /**
     * buttonProps for the modal's trigger button
     */
    buttonProps: PropTypes.object,
};

export const WarrantyModalContainer = memo(WarrantyModalComponent);

export default WarrantyModalContainer;
